import React from 'react';
import PropTypes from 'prop-types';
import SuggestionItem from './SuggestionItem';
import '../global-sass/main.scss';

const SuggestionList = ({
	suggestions,
	isVisible,
	suggestionsLabel,
	onSelect,
	highlightedIndex,
	onMouseEnter,
	onMouseLeave
}) => {
	if (!isVisible || !suggestions || suggestions.length === 0) {
		return null;
	}

	return (
		<div
			className="position-absolute h-auto form-control shadow suggestion-dropdown"
			role="listbox"
		>
			<small className="text-muted text-uppercase">
				{suggestionsLabel}
			</small>
			<ul className="list-unstyled mb-0">
				{suggestions.map((suggestion, index) => {
					const active = index === highlightedIndex;
					return (
						<SuggestionItem
							key={suggestion.placePrediction.placeId || index}
							suggestion={suggestion}
							index={index}
							isActive={active}
							onSelect={onSelect}
							onMouseEnter={onMouseEnter}
							onMouseLeave={onMouseLeave}
						/>
					);
				})}
			</ul>
		</div>
	);
};

SuggestionList.propTypes = {
	suggestions: PropTypes.arrayOf(PropTypes.shape({})),
	isVisible: PropTypes.bool.isRequired,
	suggestionsLabel: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
	highlightedIndex: PropTypes.number.isRequired,
	onMouseEnter: PropTypes.func.isRequired,
	onMouseLeave: PropTypes.func.isRequired
};

export default SuggestionList;
